import { render, staticRenderFns } from "./CommonBottom.vue?vue&type=template&id=b0891abc&scoped=true&"
import script from "./CommonBottom.vue?vue&type=script&lang=js&"
export * from "./CommonBottom.vue?vue&type=script&lang=js&"
import style0 from "./CommonBottom.vue?vue&type=style&index=0&id=b0891abc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0891abc",
  null
  
)

export default component.exports